import { useState, useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { useLang } from "@/context/LanguageContext"
import { loadGoogleAnalytics, trackPageView } from "@/lib/analytics"

const CONSENT_KEY = "clipson_cookie_consent"

function CookieConsent() {
  const { t } = useLang()
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY)
    if (!consent) {
      setShowBanner(true)
      return
    }
    if (consent === "accepted") {
      // Consentement déjà donné lors d'une visite précédente : on recharge GA automatiquement
      loadGoogleAnalytics()
      trackPageView(window.location.pathname + window.location.search)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted")
    setShowBanner(false)
    loadGoogleAnalytics()
    trackPageView(window.location.pathname + window.location.search)
  }

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "declined")
    setShowBanner(false)
    // Aucun cookie d'analyse n'est activé
  }

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="fixed bottom-0 left-0 right-0 z-50 px-4 py-6 md:px-8"
          style={{ backgroundColor: "#0D0C0B" }}
        >
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
              <div className="flex-1">
                <p className="text-base md:text-[17px] leading-relaxed" style={{ color: "#F8F2EB" }}>
                  {t(
                    "Ce site utilise des cookies pour analyser le trafic et améliorer votre expérience. En savoir plus dans notre ",
                    "This site uses cookies to analyse traffic and improve your experience. Learn more in our "
                  )}
                  <a
                    href="/privacy-policy"
                    className="underline hover:opacity-80 transition-opacity"
                    style={{ color: "#E1593F" }}
                  >
                    {t("Politique de confidentialité", "Privacy Policy")}
                  </a>
                  .
                </p>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <button
                  onClick={handleDecline}
                  className="px-6 py-2.5 rounded-lg border-2 transition-all duration-300 hover:bg-white/5 text-[15px] font-light tracking-wide"
                  style={{
                    color: "#F8F2EB",
                    borderColor: "#F8F2EB"
                  }}
                >
                  {t("Refuser", "Decline")}
                </button>

                <button
                  onClick={handleAccept}
                  className="px-6 py-2.5 rounded-lg transition-all duration-300 text-white text-[15px] font-light tracking-wide"
                  style={{
                    backgroundColor: "#E1593F"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#C4462E"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#E1593F"
                  }}
                >
                  {t("Accepter", "Accept")}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default CookieConsent
